import { render, staticRenderFns } from "./smokeDetector.vue?vue&type=template&id=04128d31"
import script from "./smokeDetector.vue?vue&type=script&lang=js"
export * from "./smokeDetector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports